import Axios from 'axios';

const authorityServer = () => {
  let AUTHORITY_SERVER = '';
  if (window.location.hostname.toLowerCase().includes('sabre'))
    AUTHORITY_SERVER = process.env.REACT_APP_SABRE_AUTHORITY_SERVER;
  else if (window.location.hostname.toLowerCase().includes('synxis'))
    AUTHORITY_SERVER = process.env.REACT_APP_SYNXIS_AUTHORITY_SERVER;
  else if (window.location.hostname.toLowerCase().includes('myma.ai'))
    AUTHORITY_SERVER = process.env.REACT_APP_MYMA_AUTHORITY_SERVER;
  else if (window.location.hostname.toLowerCase().includes('smartpabx.ai'))
    AUTHORITY_SERVER = process.env.REACT_APP_SMARTPABX_AI_AUTHORITY_SERVER;
  else AUTHORITY_SERVER = process.env.REACT_APP_AUTHORITY_SERVER;
  return AUTHORITY_SERVER;
};

export const getGroupID = () => {
  return JSON.parse(
    sessionStorage.getItem(
      `oidc.user:${authorityServer()}:${
        process.env.REACT_APP_IDENTITY_SERVER_CLIENT_APP_ID
      }`
    )
  ).profile.nickname;
};

export const getPropertyId = () => {
  let name = JSON.parse(
    sessionStorage.getItem(
      `oidc.user:${authorityServer()}:${
        process.env.REACT_APP_IDENTITY_SERVER_CLIENT_APP_ID
      }`
    )
  ).profile.family_name;
  //console.log('name', name);
  if (typeof name === 'string') {
    return name;
  } else {
    if (name && name != null && name.length >= 1) return name[1];
  }
  return undefined;
};

export const setPropertyId = () => {
  let name = JSON.parse(
    sessionStorage.getItem(
      `oidc.user:${authorityServer()}:${
        process.env.REACT_APP_IDENTITY_SERVER_CLIENT_APP_ID
      }`
    )
  ).profile.family_name;
  // console.log('name', name);
  if (typeof name === 'string') {
    return name;
  } else {
    if (name && name != null && name.length >= 1) {
      let obj = JSON.parse(
        sessionStorage.getItem(
          `oidc.user:${authorityServer()}:${
            process.env.REACT_APP_IDENTITY_SERVER_CLIENT_APP_ID
          }`
        )
      );
      if (obj?.profile && obj?.profile?.family_name)
        obj.profile.family_name = name[0];
      sessionStorage.setItem(
        `oidc.user:${authorityServer()}:${
          process.env.REACT_APP_IDENTITY_SERVER_CLIENT_APP_ID
        }`,
        JSON.stringify(obj)
      );
    }
    return;
  }
};

export const getUserRole = () => {
  let name = JSON.parse(
    sessionStorage.getItem(
      `oidc.user:${authorityServer()}:${
        process.env.REACT_APP_IDENTITY_SERVER_CLIENT_APP_ID
      }`
    )
  ).profile.family_name;
  //console.log('name', name);
  if (typeof name === 'string') {
    return name;
  } else {
    if (name && name != null && name.length > 0) return name[0];
  }
  return undefined;
};

export const getUserID = () => {
  return JSON.parse(
    sessionStorage.getItem(
      `oidc.user:${authorityServer()}:${
        process.env.REACT_APP_IDENTITY_SERVER_CLIENT_APP_ID
      }`
    )
  ).profile.sub;
};

export const getDropdownSelectedValue = () => {
  return JSON.parse(
    sessionStorage.getItem(
      `oidc.user:${authorityServer()}:${
        process.env.REACT_APP_IDENTITY_SERVER_CLIENT_APP_ID
      }`
    )
  ).profile.nickname;
};

export const AxiosAPI = (setting) => {
  const AUTHORITY_SERVER = process.env && authorityServer();
  const ACCESS_TOKEN = JSON.parse(
    sessionStorage.getItem(
      `oidc.user:${AUTHORITY_SERVER}:${process.env.REACT_APP_IDENTITY_SERVER_CLIENT_APP_ID}`
    )
  ).access_token;

  const { method, url, data, params } = setting;

  return Axios({
    method: method || '',
    url: url || '',
    data: data || null,
    params: params,
    maxContentLength: Infinity,
    maxBodyLength: Infinity,
    headers: {
      Authorization: `Bearer ${ACCESS_TOKEN}`,
    },
    timeout: 100000000,
  });
};

export const AxiosPublicAPI = (setting) => {
  const { method, url, data, params } = setting;

  return Axios({
    method: method || '',
    url: url || '',
    data: data || null,
    params: params,
  });
};

export const AxiosStripeAPI = (setting) => {
  const { method, url, data, params } = setting;
  return Axios({
    method: method || '',
    url: `https://api.stripe.com/${url}` || '',
    data: data || null,
    params: params,
    headers: {
      Authorization: `Bearer ${process.env.REACT_APP_STRIPE_KEY}`,
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
};

export const AxiosStripeAPI_US = (setting) => {
  const { method, url, data, params } = setting;
  return Axios({
    method: method || '',
    url: `https://api.stripe.com/${url}` || '',
    data: data || null,
    params: params,
    headers: {
      Authorization: `Bearer ${process.env.REACT_APP_STRIPE_KEY_US}`,
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
};

export const AxiosUserAPI = (setting) => {
  const { method, url, data, params } = setting;
  const AUTHORITY_SERVER = process.env && authorityServer();
  const ACCESS_TOKEN = JSON.parse(
    sessionStorage.getItem(
      `oidc.user:${AUTHORITY_SERVER}:${process.env.REACT_APP_IDENTITY_SERVER_CLIENT_APP_ID}`
    )
  ).access_token;
  return Axios({
    method: method || '',
    url: url || '',
    data: data || null,
    maxContentLength: Infinity,
    headers: {
      Authorization: `Bearer ${ACCESS_TOKEN}`,
    },
    maxBodyLength: Infinity,
    params: params,
  });
};

export const setSelectedGroup = (selectedGroup) => {
  window.sessionStorage.setItem('groupId', JSON.stringify(selectedGroup));
};

export const getSelectedGroup = () => {
  const group = window.sessionStorage.getItem('groupId');
  return group ? JSON.parse(group) : undefined;
};

export const removeSelectedGroup = () => {
  const group = window.sessionStorage.removeItem('groupId');
  return group ? JSON.parse(group) : undefined;
};
